import React from 'react';
import logo from '../assets/logo.png';

const Logo: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`flex items-center h-16 pl-6 ${className}`}>
    <img src={logo} alt="CodeSplash Logo" className="h-10 w-auto" />
  </div>
);

export default Logo; 